import React from 'react';

const link1 = <a href="https://www.dropbox.com/s/96qwvdqqrvzq3x0/Generac_A0000528139_DataSheet.pdf?dl=0" target="_blank" rel="noopener noreferrer">PWRcell Data Sheet (PDF)</a>;


const Battery = () => (
    <div>
        <p className="specsText">PWRcell&#39;s revolutionary technology captures and stores electricity - either from solar panels, or the electrical grid. It allows you to use stored energy during peak demand times when electricity costs are high, which ultimately helps reduce your electric bill and save some money. In the case of a power outage, PWRcell is ready to supply backup power to your home.
        </p>
        <p className="specsText">PWRcell provides up to 10kW of surge power, enough to start an air conditioner or sump pump. Access up to 8kW of continuous output, plenty to run most homes.
        </p>
        <p className="specsText">Each PWRcell battery is easily configurable from 8.6kWh to 17.1kWh to meet any budget or lifestyle.
        </p>
        <h1>Key Features</h1>
        <ul>
            <li className="specsText">Valuable insight and savings with the PWRView APP</li>
            <li className="specsText">Get real-time understanding of your energy use</li>
            <li className="specsText">View dashboards for daily consumption, solar generation and battery usage along with bill estimates and savings.
            </li>
            <li className="specsText">Keep energy spending in check with detailed bill tracking, forecast and history.</li>
            <li className="specsText">{link1}</li>
        </ul>
    </div>
);


export default Battery;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/Batteries/generacStorage.js